import React from "react";
import PageShell from "../components/layout/PageShell";

export default function PolitiqueConfidentialite() {
  return (
    <PageShell
      title="Politique de confidentialité"
      subtitle="Règles relatives à la collecte et au traitement des données sur la plateforme."
    >
      <h2 className="ema-h3">1. Objet</h2>
      <p className="ema-paragraph">
        La présente politique explique comment l’École de la Magistrature traite les données personnelles collectées via le site
        et l’Espace candidat (inscription aux concours, demandes d’information, accès aux services).
      </p>

      <div className="ema-divider" />

      <h2 className="ema-h3">2. Données collectées</h2>
      <ul className="ema-list">
        <li>Données d’identification : nom, prénom, date/lieu de naissance (si requis), coordonnées</li>
        <li>Données de compte : email, identifiant, informations de connexion</li>
        <li>Données de candidature : parcours, informations déclaratives, pièces justificatives téléversées</li>
        <li>Données techniques : logs de sécurité, adresse IP, informations navigateur (à des fins de sécurité)</li>
      </ul>

      <div className="ema-divider" />

      <h2 className="ema-h3">3. Finalités</h2>
      <ul className="ema-list">
        <li>Gestion des candidatures et concours (création de compte, dépôt et suivi de dossier)</li>
        <li>Publication/notification d’informations relatives au processus (convocations, résultats, avis)</li>
        <li>Sécurisation des accès et prévention de la fraude</li>
        <li>Amélioration des services et du fonctionnement du site</li>
      </ul>

      <div className="ema-divider" />

      <h2 className="ema-h3">4. Base légale</h2>
      <p className="ema-paragraph">
        Les traitements de données sont réalisés dans le cadre de la mission institutionnelle de l’École (service public),
        et/ou sur la base du consentement lorsque nécessaire (ex. formulaire de contact).
      </p>

      <div className="ema-divider" />

      <h2 className="ema-h3">5. Durée de conservation</h2>
      <p className="ema-paragraph">
        Les données sont conservées pendant la durée nécessaire au traitement des candidatures, puis archivées selon les règles
        administratives applicables. Les logs techniques peuvent être conservés pour une durée limitée à des fins de sécurité.
      </p>

      <div className="ema-divider" />

      <h2 className="ema-h3">6. Partage des données</h2>
      <p className="ema-paragraph">
        Les données sont accessibles uniquement aux personnes habilitées (administration EMA / commissions autorisées) et aux
        prestataires techniques strictement nécessaires à l’hébergement et à la sécurité, sous obligations de confidentialité.
      </p>

      <div className="ema-divider" />

      <h2 className="ema-h3">7. Sécurité</h2>
      <p className="ema-paragraph">
        Des mesures organisationnelles et techniques sont mises en place : contrôle d’accès, authentification, journalisation,
        chiffrement en transit (HTTPS) et sauvegardes.
      </p>

      <div className="ema-divider" />

      <h2 className="ema-h3">8. Droits des personnes</h2>
      <p className="ema-paragraph">
        Selon les règles applicables, vous pouvez demander l’accès, la rectification ou la mise à jour de vos informations.
        Pour exercer ces droits, contactez l’École via la page <strong>Contact</strong>.
      </p>

      <div className="ema-divider" />

      <h2 className="ema-h3">9. Mise à jour</h2>
      <p className="ema-paragraph">
        Cette politique peut être mise à jour pour refléter des évolutions légales, techniques ou organisationnelles.
      </p>
    </PageShell>
  );
}

